<template>
  <div
    class="file-upload"
    @drop="handleFileDrop"
    @dragenter="handleDragEnter"
    @dragleave="handleDragLeave"
    @dragover="handleDragOver"
  >
    <input
      data-private
      ref="inputFile"
      class="d-none"
      type="file"
      :accept="joinedValidFormats"
      name="file"
      :id="id"
      :disabled="disabled"
      @change="handleInputFileChange"
    />

    <slot :selectFile="handleSelectFile" :isDraggingFile="isDraggingFile" />
  </div>
</template>

<script>
import uuid from 'uuid/v4'
import _ from 'lodash'

import mixin from '@/mixins/mixin.vue'

export default {
  mixins: [mixin],

  props: {
    id: {
      type: String,
      default: uuid(),
    },
    validFormats: {
      type: Array,
      default: () => [],
    },

    disabled: Boolean,
  },

  data() {
    return {
      isDraggingFile: false,
    }
  },

  computed: {
    joinedValidFormats() {
      return this.validFormats?.join(', ')
    },
  },

  methods: {
    handleFileDrop(event) {
      event.preventDefault()
      event.dataTransfer.effectAllowed = 'none'

      if (this.disabled) return

      const files = Array.from(event?.dataTransfer?.files ?? [])

      this.isDraggingFile = false
      this.handleFilesSelected(files)
    },

    handleDragEnter(event) {
      event.preventDefault()
      event.dataTransfer.effectAllowed = 'none'

      if (this.disabled || this.isDraggingFile) return
      this.isDraggingFile = true
    },

    handleDragLeave() {
      if (this.disabled || !this.isDraggingFile) return
      this.isDraggingFile = false
    },

    handleDragOver(event) {
      event.preventDefault()
      event.dataTransfer.effectAllowed = 'none'
      if (this.disabled || this.isDraggingFile) return
      this.isDraggingFile = true
    },

    handleSelectFile() {
      if (this.disabled) return

      this.$refs.inputFile.click()
    },

    handleInputFileChange(event) {
      const files = Array.from(
        event?.target?.files ?? event?.dataTransfer?.files ?? []
      )

      this.$refs.inputFile.value = ''

      this.handleFilesSelected(files)
    },

    async handleFilesSelected(files) {
      if (_.isEmpty(files)) return

      try {
        this.validateFiles(files)
        this.$emit('selected', files)
      } catch (error) {
        this.showError(error?.message)
      }
    },

    validateFiles(files) {
      files.map(file => {
        const fileType = file?.type
        if (!this.validFormats.includes(fileType)) {
          throw new Error(
            this.$t('fileLoader.error', {
              supportedExtensions: this.validFormats.join(', '),
            })
          )
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.file-upload {
  width: 100%;
  height: 100%;
}
</style>
